var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 125,
    height: 125,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-391 -163)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 391, 163)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 53.5,
    r: 53.5,
    transform: "translate(9 6)",
    fill: "#8c549a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.311,8.942a6,6,0,0,1,10.379,0L59.77,46.988A6,6,0,0,1,54.581,56H10.419A6,6,0,0,1,5.23,46.988Z",
    transform: "translate(490 187) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,6.953a4.951,4.951,0,0,0-4.324,2.49L6.095,47.49A5,5,0,0,0,10.419,55H54.581a5,5,0,0,0,4.324-7.51L36.824,9.444A4.951,4.951,0,0,0,32.5,6.953m0-1a5.944,5.944,0,0,1,5.189,2.988L59.77,46.988A6,6,0,0,1,54.581,56H10.419A6,6,0,0,1,5.23,46.988L27.311,8.942A5.944,5.944,0,0,1,32.5,5.953Z",
    transform: "translate(490 187) rotate(90)",
    fill: "#707070"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.fed8ac6de021b354ca16fa409382182b.svg";
export { ForwardRef as ReactComponent };